import { Pipe, PipeTransform } from '@angular/core';

/**
 * A pipe which transforms a numeric value of degrees Celsius into the equivalent numeric value of degrees Fahrenheit.
 * For example, the value `37` would be transformed into the value `98.6`, as 37.0°C is equivalent to 98.6°F.
 */
@Pipe({
  name: 'toFahrenheit'
})
export class ToFahrenheitPipe implements PipeTransform {
  /**
   * A pipe which transforms a numeric value of degrees Celsius into the equivalent numeric value of degrees Fahrenheit.
   * For example, the value `37` would be transformed into the value `98.6`, as 37.0°C is equivalent to 98.6°F.
   * @param celsiusValue the temperature value in Celsius
   * @returns the equivalent temperature value in Fahrenheit
   */
  transform(celsiusValue: number): number {
    /** convert the Celsius value into its exact equivalent Fahrenheit value */
    return (celsiusValue * 9 / 5) + 32;
  }

}
